type GetDomain = (hostname: string) => string;

export const getDomain: GetDomain = (hostname) => {
  return `.${hostname}`;
};
